'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var KeyboardArrowRight = {};

exports.__exports = KeyboardArrowRight;
